import createEntityBundle from '~/src/Lib/createEntityBundle'
import { CultivarStatistic as schema } from '~/src/Store/Schemas'

const bundle = createEntityBundle({
  name: 'cultivarStatistics',
  apiConfig: { schema, url: 'cultivarStatistic' },
})

export default bundle
